import { MapState } from 'src/app/interfaces/map.interface';
import { Coords, FullUser, SearchResult } from 'src/app/swagger-api';
import { DiametricalCoordsCreatorFactory } from '../factories/diametrical-coords-creator.factory';
import { getSearchNonAggregationUserDecoratedResult } from './decorators.helpers';
import { SharedResponseCoordsProcessorDecorator } from './shared-response-coords-processor.decorator';
import { NonAggregationProcessorType } from './shared-response-processor.decorator';

export class UserCoordsProcessorDecorator extends SharedResponseCoordsProcessorDecorator<SearchResult> {
  public constructor(entity: NonAggregationProcessorType, state: MapState) {
    super(entity, state);
  }

  protected override getDecoratedItemsCoords(results: SearchResult[]): SearchResult[] {
    const points: Coords[] = DiametricalCoordsCreatorFactory.createCoordsList({
      center: (results[0].item as FullUser).profile.location.center,
      radius: this.getRadius({ pinsCount: results.length }),
      count: results.length,
    });
    return super.getDecoratedItemsCoords(
      results.map((item: SearchResult, index: number) =>
        getSearchNonAggregationUserDecoratedResult(item, points[index]),
      ),
    );
  }

  protected override groupItemsByCoords(results: SearchResult[]): Map<string, SearchResult[]> {
    return super.groupItemsByCoords(
      results,
      (current: SearchResult) => {
        const coords: Coords = (current.item as FullUser).profile.location.center;
        return `${coords.lat}_${coords.lon}`;
      },
      (current: SearchResult) => current,
    );
  }
}
